import React from "react"
import * as socialStyles from "./SocialShare.module.css"

export default function SocialShare({
  center = true,
  showTitle = true,
  sharingText = "Die Seo Agentur in Stuttgart ‖‖‖▶ bietet Premium Optimierungen für Ihre Webseite an ✅ Mit unserer Erfolgs-Garantie ‖‖‖▷ gehen Sie auf Nummer sicher!",
}) {
  const isClient = typeof window !== "undefined"

  const currentPage = isClient
    ? window.location.href
    : "https://www.seo-premium-agentur.de/"

  return (
    <>
      {showTitle && <div className={center ? "text-center" : ""}>Teilen:</div>}
      <div className={center ? "flex justify-center mb-5" : "flex"}>
        <div>
          <a
            className={`${socialStyles.socialSharingButton} ${socialStyles.circle} ${socialStyles.facebook}`}
            id="facebook"
            href={`https://www.facebook.com/sharer/sharer.php?u=${currentPage}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Share on Facebook"
          >
            <svg
              height={512}
              viewBox="0 0 24 24"
              width={512}
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Seo Agentur Stuttgar Facebook Profil</title>
              <path d="m15.997 3.985h2.191v-3.816c-.378-.052-1.678-.169-3.192-.169-3.159 0-5.323 1.987-5.323 5.639v3.361h-3.486v4.266h3.486v10.734h4.274v-10.733h3.345l.531-4.266h-3.877v-2.939c.001-1.233.333-2.077 2.051-2.077z" />
            </svg>
          </a>
          <a
            className={`${socialStyles.socialSharingButton} ${socialStyles.circle} ${socialStyles.twitter}`}
            id="twitter"
            href={`https://twitter.com/intent/tweet/?text=${sharingText}%20${currentPage}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Share on Twitter"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              xmlSpace="preserve"
            >
              <title>Seo Agentur Stuttgar Twitter Profil</title>

              <g>
                <path
                  d="M512,97.248c-19.04,8.352-39.328,13.888-60.48,16.576c21.76-12.992,38.368-33.408,46.176-58.016
 c-20.288,12.096-42.688,20.64-66.56,25.408C411.872,60.704,384.416,48,354.464,48c-58.112,0-104.896,47.168-104.896,104.992
 c0,8.32,0.704,16.32,2.432,23.936c-87.264-4.256-164.48-46.08-216.352-109.792c-9.056,15.712-14.368,33.696-14.368,53.056
 c0,36.352,18.72,68.576,46.624,87.232c-16.864-0.32-33.408-5.216-47.424-12.928c0,0.32,0,0.736,0,1.152
 c0,51.008,36.384,93.376,84.096,103.136c-8.544,2.336-17.856,3.456-27.52,3.456c-6.72,0-13.504-0.384-19.872-1.792
 c13.6,41.568,52.192,72.128,98.08,73.12c-35.712,27.936-81.056,44.768-130.144,44.768c-8.608,0-16.864-0.384-25.12-1.44
 C46.496,446.88,101.6,464,161.024,464c193.152,0,298.752-160,298.752-298.688c0-4.64-0.16-9.12-0.384-13.568
 C480.224,136.96,497.728,118.496,512,97.248z"
                />
              </g>
            </svg>
          </a>
          <a
            className={`${socialStyles.socialSharingButton} ${socialStyles.circle} ${socialStyles.eMail}`}
            id="e-mail"
            href={`mailto:?subject=${sharingText}&amp;body=${currentPage}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Share by E-Mail"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 372.444 372.444"
              xmlSpace="preserve"
            >
              <title>Seo Agentur Stuttgar per E-Mail teilen</title>

              <g>
                <path d="M356.92,57.712H15.525C6.986,57.712,0,64.7,0,73.236v225.971c0,8.539,6.986,15.525,15.525,15.525H356.92 c8.538,0,15.524-6.986,15.524-15.525V73.236C372.444,64.699,365.458,57.712,356.92,57.712z M242.954,197.005 c28.809,19.424,103.25,77.049,103.25,77.049c2.965,2.009,3.177,7.16,1.693,10.229c-1.483,3.07-6.122,4.938-9.087,2.93 c0,0-79.24-57.212-109.561-77.969c-1.678-1.148-3.164,0.23-3.164,0.23l-33.247,26.527c-1.818,1.492-4.215,2.314-6.745,2.314 s-4.926-0.822-6.746-2.314l-33.629-26.838c0,0-1.158-1.009-2.475-0.096c-29.972,20.805-108.867,78.145-108.867,78.145 c-2.964,2.009-8.604,0.141-10.087-2.93c-1.483-3.068-1.271-8.22,1.693-10.229c0,0,74.535-57.445,102.884-76.768 c1.619-1.104-0.08-2.727-0.08-2.727L23.662,99.908c-3.822-3.133-4.966-8.744-2.605-12.775c1.402-2.398,3.872-3.83,6.604-3.83 c1.924,0,3.865,0.723,5.466,2.035l149.502,131.025c0.883,0.723,2.145,1.139,3.464,1.139s2.581-0.416,3.465-1.139L339.059,85.338 c1.601-1.313,3.542-2.035,5.467-2.035c2.732,0,5.201,1.432,6.604,3.83c2.36,4.031,1.216,9.643-2.604,12.775l-105.404,94.945 C243.121,194.854,241.636,196.114,242.954,197.005z" />
              </g>
            </svg>
          </a>
          <a
            className={`${socialStyles.socialSharingButton} ${socialStyles.circle} ${socialStyles.linkedin}`}
            id="linkedin"
            href={`https://www.linkedin.com/shareArticle?mini=true&url=${currentPage}&title=${sharingText}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Share on LinkedIn"
          >
            <svg
              height={512}
              viewBox="0 0 24 24"
              width={512}
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Seo Agentur Stuttgar LinkedIn Profil</title>

              <path d="m23.994 24v-.001h.006v-8.802c0-4.306-.927-7.623-5.961-7.623-2.42 0-4.044 1.328-4.707 2.587h-.07v-2.185h-4.773v16.023h4.97v-7.934c0-2.089.396-4.109 2.983-4.109 2.549 0 2.587 2.384 2.587 4.243v7.801z" />
              <path d="m.396 7.977h4.976v16.023h-4.976z" />
              <path d="m2.882 0c-1.591 0-2.882 1.291-2.882 2.882s1.291 2.909 2.882 2.909 2.882-1.318 2.882-2.909c-.001-1.591-1.292-2.882-2.882-2.882z" />
            </svg>
          </a>
          <a
            className={`${socialStyles.socialSharingButton} ${socialStyles.circle} ${socialStyles.xing}`}
            id="xing"
            href={`https://www.xing.com/app/user?op=share;url=${currentPage};title=${sharingText}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Share on Xing"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="95.428px"
              height="95.428px"
              viewBox="0 0 95.428 95.428"
              xmlSpace="preserve"
            >
              <title>Seo Agentur Stuttgar Xing Profil</title>

              <g>
                <path d="M32.098,21.426c-0.686-1.22-1.721-2.58-3.832-2.58H14.502c-0.829,0-1.525,0.291-1.877,0.86 c-0.363,0.588-0.306,1.345,0.079,2.111l9.305,16.109c0.017,0.031,0.017,0.05,0,0.079L7.387,63.811 c-0.383,0.76-0.363,1.523,0,2.111c0.35,0.566,0.969,0.938,1.798,0.938h13.764c2.058,0,3.049-1.389,3.753-2.657 c0,0,14.301-25.293,14.858-26.275C41.503,37.836,32.098,21.426,32.098,21.426z" />
                <path d="M88.027,3.003c0.382-0.76,0.392-1.536,0.027-2.124C87.704,0.313,87.053,0,86.225,0H72.321 c-2.054,0-2.946,1.295-3.685,2.621c0,0-29.649,52.58-30.625,54.308c0.05,0.095,19.555,35.878,19.555,35.878 c0.683,1.221,1.735,2.621,3.845,2.621h13.748c0.828,0,1.477-0.312,1.826-0.879c0.366-0.588,0.355-1.363-0.027-2.127L57.555,56.973 c-0.02-0.027-0.02-0.062,0-0.091L88.027,3.003z" />
              </g>
            </svg>
          </a>
          <a
            className={`${socialStyles.socialSharingButton} ${socialStyles.circle} ${socialStyles.whatsapp}`}
            id="whatsapp"
            href={`whatsapp://send?text=${sharingText}%20${currentPage}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Share on WhatsApp"
          >
            <svg
              height="682pt"
              viewBox="-23 -21 682 682.66669"
              width="682pt"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m544.386719 93.007812c-59.875-59.945312-139.503907-92.9726558-224.335938-93.007812-174.804687 0-317.070312 142.261719-317.140625 317.113281-.023437 55.894531 14.578125 110.457031 42.332032 158.550781l-44.992188 164.335938 168.121094-44.101562c46.324218 25.269531 98.476562 38.585937 151.550781 38.601562h.132813c174.785156 0 317.066406-142.273438 317.132812-317.132812.035156-84.742188-32.921875-164.417969-92.800781-224.359376zm-224.335938 487.933594h-.109375c-47.296875-.019531-93.683594-12.730468-134.160156-36.742187l-9.621094-5.714844-99.765625 26.171875 26.628907-97.269531-6.269532-9.972657c-26.386718-41.96875-40.320312-90.476562-40.296875-140.28125.054688-145.332031 118.304688-263.570312 263.699219-263.570312 70.40625.023438 136.589844 27.476562 186.355469 77.300781s77.15625 116.050781 77.132812 186.484375c-.0625 145.34375-118.304687 263.59375-263.59375 263.59375zm144.585938-197.417968c-7.921875-3.96875-46.882813-23.132813-54.148438-25.78125-7.257812-2.644532-12.546875-3.960938-17.824219 3.96875-5.285156 7.929687-20.46875 25.78125-25.09375 31.066406-4.625 5.289062-9.242187 5.953125-17.167968 1.984375-7.925782-3.964844-33.457032-12.335938-63.726563-39.332031-23.554687-21.011719-39.457031-46.960938-44.082031-54.890626-4.617188-7.9375-.039062-11.8125 3.476562-16.171874 8.578126-10.652344 17.167969-21.820313 19.808594-27.105469 2.644532-5.289063 1.320313-9.917969-.664062-13.882813-1.976563-3.964844-17.824219-42.96875-24.425782-58.839844-6.4375-15.445312-12.964843-13.359374-17.832031-13.601562-4.617187-.230469-9.902343-.277344-15.1875-.277344-5.28125 0-13.867187 1.980469-21.132812 9.917969-7.261719 7.933594-27.730469 27.101563-27.730469 66.105469s28.394531 76.683594 32.355469 81.972656c3.960937 5.289062 55.878906 85.328125 135.367187 119.648438 18.90625 8.171874 33.664063 13.042968 45.175782 16.695312 18.984374 6.03125 36.253906 5.179688 49.910156 3.140625 15.226562-2.277344 46.878906-19.171875 53.488281-37.679687 6.601563-18.511719 6.601563-34.375 4.617187-37.683594-1.976562-3.304688-7.261718-5.285156-15.183593-9.253906zm0 0"
                fillRule="evenodd"
              />
            </svg>
          </a>
        </div>
      </div>
    </>
  )
}
